import { CANON_STATES, type StateSpec, TYPE_KEYS, type TypeKey } from '@codex/ui';

/** The glyph of a page's type; a user type the design has no glyph for shows the note glyph. */
export function glyphFor(typeKey: string): TypeKey {
  return (TYPE_KEYS as readonly string[]).includes(typeKey) ? (typeKey as TypeKey) : 'note';
}

export function canonSpec(status: string): StateSpec | null {
  return status in CANON_STATES ? CANON_STATES[status as keyof typeof CANON_STATES] : null;
}
